import { Component, OnDestroy, OnInit, ViewChild, TemplateRef, ChangeDetectorRef, ElementRef } from '@angular/core';
import { NbComponentStatus, NbDialogService, NbGlobalPhysicalPosition, NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService, NbToastrService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil, startWith } from 'rxjs/operators';
import { Subject, Observable, Subscription } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { Router } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { Tracing } from 'trace_events';
import { BranchService } from '../../../services/branch.service';
import { FormControl, FormGroup } from '@angular/forms';
import { BranchFilterService } from '../../../services/branch-filter.service';
import { AuthService } from '../../../services/auth.service';
import { environment } from '../../../../environments/environment';
import { id } from '@swimlane/ngx-charts';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: any;

  // selectedFilter = 0;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  currentTheme = 'default';

  userMenu = [
    // { title: 'Edit Profile' },
    // { title: 'Change Password' },
    { title: 'Log out' },
  ];

  dev_environment = environment.dev_environment;

  @ViewChild('dialogRef', {read: TemplateRef}) dialogRef: TemplateRef<any>;

  public constructor(
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userDataService: UserData,
    private userService: UserService,
    private branchService: BranchService,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
    private router: Router,
    private dialogService: NbDialogService,
    private branchFilterService: BranchFilterService,
    private changeDetector : ChangeDetectorRef,
    private authSrvc: AuthService,
    private toastrService: NbToastrService,
  ) {
    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }));
  }

  branchFilterSubscription: Subscription
  branchPinnedSubscription: Subscription

  ngOnInit() {     
    this.currentTheme = this.themeService.currentTheme;

    this.user = JSON.parse(localStorage.getItem('user'))
    // console.log(this.user);
    if(!this.user) {
      this.logout();
    }
    else {
      // this.userService.get(this.user.id).subscribe(u => {
        // console.log(u);
        this.userService.update({id: this.user.id}).subscribe(data => {
          console.log("user successfully connected");
          // console.log(data);
        }, err => {
          console.log("error connecting to server, please retry login");
          this.logout();
        });
      // });
    }

    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });

      this.menuService.onItemClick().subscribe((event) => {
        this.action(event.item.title)
      })

      if(localStorage.getItem('userRole') == 'agent' || localStorage.getItem('userRole') == 'superAdmin'){
        this.branchFilterSubscription = this.branchFilterService.branchCreated$.subscribe(idx => {
          console.log('load branch options');
          this.getBranches();
        });
      }
      this.branchPinnedSubscription = this.branchFilterService.branchPinned$.subscribe(idx => {
        // console.log('branch pinned');
        this.onBranchPinned();
      });
      this.getBranches();
  }

  action(evt){
    switch(evt){
      case 'Log out':
        this.logoutDialog();
        // localStorage.clear();
        // this.router.navigate(['auth/login']);
        break;
    }
  }
  
  confirmDialog:any;
  logoutDialog(){
    console.log('logout dialog');
    this.confirmDialog = this.dialogService.open(
      this.dialogRef
      );
  }

  logout(){
    localStorage.clear();
    this.router.navigate(['auth/login']);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if(localStorage.getItem('userRole') == 'agent' || localStorage.getItem('userRole') == 'superAdmin') {
      this.branchFilterSubscription.unsubscribe();
    }
    this.branchPinnedSubscription.unsubscribe();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  navigateHome() {
    this.menuService.navigateHome();
    return false;
  }

  userRole : string;
  branchAll : any = [];
  branchFilter: any = {};
  branchOptions : any = [];
  showFilter = false;
  placeHolderName = "";

  form = new FormGroup({
    branchFilter: new FormControl(''),
  });

  getBranches() {
    this.branchService.getList().subscribe(data => {
      this.branchAll = data;
      // console.log("list", data);

      this.branchOptions = [];

      var branches = data as any[];
      this.branchFilter = [];
      // console.log(branches);

      const filter = localStorage.getItem('branchFilter');
      console.log(filter);

      filter.split(' ').forEach(f => {
        branches.forEach(b => {
          // console.log(f + " ... " + b.id + " = " + (f==b.id));
          if(b.id && f == b.id){
            this.branchFilter.push(b);
          }
        })
      })
      console.log('filter:')
      console.log(this.branchFilter);

      this.userRole = localStorage.getItem('userRole');
      if(this.userRole == 'merchant' || this.userRole == 'receptionist'){
        branches.forEach(b => {
          this.branchFilter.forEach(f => {
            // console.log(f.id + " == " + b.id + " = " + (f.id == b.id));
            if(f.id == b.id){
              this.branchOptions.push(b);
            }
          });
        })
        
        console.log('loaded some')
      } else {
        console.log('loaded all')
        this.branchOptions = data;
      }

      this.branchOptions.sort((a, b) => {
        if ( a.branchName < b.branchName ){
          return -1;
        }
        if ( a.branchName > b.branchName ){
          return 1;
        }
        return 0;
      });

      if(this.userRole == 'admin' || this.userRole == 'agent') {
        this.branchOptions = [{branchName: "(ALL BRANCHES)",id: 0,}].concat(this.branchOptions as any[]);
      }
      // console.log(this.branchOptions);

      this.filteredOptions = [];
      this.filteredOptions = [...this.branchOptions];
      // console.log(this.filteredOptions);

      this.branchFilter2.patchValue(this.branchOptions[0].branchName);
      this.changeDetector.detectChanges();
      this.showFilter = true;

      var storedBranch = localStorage.getItem('selectedBranch');
      var storedBranchItem : any;
      
      if(storedBranch && storedBranch != '') {
        storedBranchItem = this.branchOptions.find(b => {return b.id == parseInt(storedBranch)});
      }
      else{
        storedBranch = this.branchOptions.id;
        storedBranchItem = this.branchOptions[0];

        var zeroValue:any = 0
        localStorage.setItem('branchTourmindId', zeroValue);

        console.log("Stored branch not found");
        console.log(storedBranchItem);
      }

      this.branchFilter2.setValue(
        storedBranchItem
      );
      // this.placeHolderName = storedBranchItem.branchName;
      // console.log(this.branchFilter2.value);
      this.onBranchSelectExtension(storedBranchItem.branchName, storedBranchItem);
      // console.log("STORED BRANCH HERE:", storedBranchItem);
    });
  }

  onBranchSelectExtension (branchName: string, branch) {

    localStorage.setItem('selectedBranch', branch.id);
    localStorage.setItem('selectedBranchItem', JSON.stringify(branch));
    // console.log("select branch obj", branch);
    // localStorage.setItem('branchTourmindId', )
    // console.log( evt);
    // console.log( evt.option.viewValue );
    // this.placeHolderName = branchName;
    this.branchFilterService.menuChoosen$.next(branch.id);
  }

  onBranchSelect(evt: any) {
    localStorage.removeItem('branchTourmindId');
    console.log("EVENT",evt.option.value);
    if(evt.option.value.tourmindId && evt.option.value.tourmindId !== 0){
      console.log("SET TOURMIND ID");
      this.branchService.setStoredTourmindId(evt.option.value.tourmindId);
    }
    else{
      console.log("TOURMIND WILL BE ZERO")
      this.branchService.setStoredTourmindId(0);
    }
    if(evt.option.value !== null) {
      this.onBranchSelectExtension(evt.option.value.branchName, evt.option.value);
    }
  }

  highlightBranch = "normal";
  onBranchPinned() {
    this.getBranches();

    var newlyBranch = JSON.parse(localStorage.getItem('newlyBranch'));
      console.log("newly branch", newlyBranch);
    if(newlyBranch != null) {
      this.filteredOptions.push(newlyBranch);
    }

    var id = parseInt(localStorage.getItem('selectedBranch'));
    // console.log(id);
    this.branchFilterService.menuChoosen$.next(id);
    setTimeout(() => this.form.setValue({branchFilter: id}));
    
    // this.form.controls.selected.setValue(id);
    // this.changeDetector.markForCheck();
    // this.selectedFilter = id;

    this.branchFilter2.setValue(this.branchOptions.find(b => {
      return b.id == id;
    }));
    this.highlightBranch = "highlight";
    console.log(this.highlightBranch);
    setTimeout(() => {
      this.highlightBranch = "normal"; 
      console.log(this.highlightBranch);
    }, 300);

  }

  private showToast(type: NbComponentStatus, title: string, body: string) {
    const config = {
      status: type,
      destroyByClick: true,
      duration: 5000,
      hasIcon: true,
      position: NbGlobalPhysicalPosition.TOP_RIGHT,
      preventDuplicates: true,
    };
    const titleContent = title ? `. ${title}` : '';

    this.toastrService.show(
      body,
      titleContent,
      config);
  }

  // Autocomplete
  
  @ViewChild('branchInput') branchInput: ElementRef<HTMLInputElement>;
  branchFilter2 = new FormControl();
  filteredOptions: any[];

  private _filter() {
    const filterValue = this.branchInput.nativeElement.value.toLowerCase();
    // console.log(this.branchOptions);
    this.filteredOptions = this.branchOptions.filter(option => option && option.branchName && option.branchName.toLowerCase().includes(filterValue));
  }

  displayFn(branch) {
    // console.log(branch);
    // console.log(this.branchOptions);
    return branch ? branch.branchName : "";
  }

}
